export default __webpack_public_path__ + "static/ai-marketing-5-92ee6fab25800f14f57a5095ff4c03ea.png";